const hasQuantityDaysToDueDate = email =>
  email.variables.hasOwnProperty('quantityDaysToDueDate')

export default hasQuantityDaysToDueDate
